import { render } from "./AddCategory.vue?vue&type=template&id=018d4ab8&scoped=true"
import script from "./AddCategory.vue?vue&type=script&lang=js"
export * from "./AddCategory.vue?vue&type=script&lang=js"

import "./AddCategory.vue?vue&type=style&index=0&id=018d4ab8&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-018d4ab8"]])

export default __exports__